<template>
  <v-row justify="center">
    <v-col
      cols="12"
      sm="10"
    >
      <v-dialog
        v-model="show"
        transition="dialog-bottom-transition"
        width="clamp(350px, 50%, 50%)"
      >
        <v-card>
          <v-toolbar
            color="blue"
            dark
          >
            <v-toolbar-title
              class="ml-3"
              v-html="title"
            />
          </v-toolbar>
          <v-card-text class="mt-2">
            <autocomplete
              ref="autocomplete"

              :get-result-value="getResultValue"
              :search="search"
              @submit="onSubmit"
            />
          </v-card-text>
          <v-card-text>
            <v-data-table
              v-model="selectedItem"
              show-select
              :single-select="false"
              :headers="headers"
              :items="items"
              :options="{ itemsPerPage: 10 }"
              :page="currentPage"
              locale="ru-RU"
              :footer-props="datatableFooter"
              no-data-text="Нет данных для отображения"
              :item-key="itemKey"
            >
              <!--              <template v-slot:item.actions="{ item }">-->
              <!--                <v-btn-->
              <!--                  color="primary"-->
              <!--                  icon-->
              <!--                  :ripple="{class: 'blue&#45;&#45;text'}"-->
              <!--                  @click="chooseItem(item)"-->
              <!--                >-->
              <!--                  <v-icon>-->
              <!--                    mdi-account-plus-outline-->
              <!--                  </v-icon>-->
              <!--                </v-btn>-->
              <!--              </template>-->
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider />
          <v-card-actions class="d-flex justify-space-around">
            <v-btn
              outlined
              color="primary"
              @click="closeDialog"
            >
              Отмена
            </v-btn>
            <v-btn
              color="primary"
              @click="chooseItem"
            >
              Выбрать
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import Autocomplete from "@/views/loyalty/shared/components/search-autocomplete/Autocomplete.vue"
import { getObjectsForSearching, getSearchedObjects } from "@/views/loyalty/shared/modules/utilities"

export default {
  name: "ItemList",
    components: { Autocomplete },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    headers: {
      default: () => []
    },
      itemKey: {
        default: ""
      },
    itemList: {
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
      title: {
        type: String,
          default: ''
      },
      selectedItem: {
          default: () => []
      },
  },
  data: () => ({
    currentPage: 1,
    datatableFooter: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
      items: [],
    pageStart: 0,
    pageStop: 0,
    // selected: []
  }),
  computed: {
    show: {
      get: function () {
        return this.dialogVisible
      },
      set: function () {
        this.$emit("close")
      }
    }
  },
    watch: {
      itemList: {
          handler (newValue, oldValue) {
              this.items = newValue
          }
      }
    },
  methods: {
    chooseItem () {
      // console.log(item)
      console.log('selected=', this.selectedItem)
      this.$emit("getItem", this.selectedItem)
      this.$emit("close")
    },
    closeDialog () {
      this.$emit("close")
    },
    getPagination (item) {
      console.log(`pagination=${JSON.stringify(item)}`)
      this.pageStart = item.pageStart
      this.pageStop = item.pageStop
    },
      getResultValue (result) {
          return result.searched
      },
      onSubmit (result) {
          const searching = result.searched ? result.searched : result
          if (searching.length !== 0) {
              this.items = getObjectsForSearching(this.items, searching)
          } else {
              this.items = this.itemList
          }
      },
      search (input) {
          console.log('search', input)
          if (input.length < 1) { return [] }
          const arr = getSearchedObjects(this.items, input)
          console.log('arr', arr)
          return arr
      },
  }
}
</script>

<style scoped></style>
